/* eslint-disable no-unused-vars */
import SwiperCore from 'swiper/core';

const swiper = new SwiperCore('.swiper-container-featured', {
    slidesPerView: 1.4,
    spaceBetween: 20,
    preventClicks: false,
    preventClicksPropagation: false,
    slideToClickedSlide: false,
    breakpoints: {
        600: {
            slidesPerView: 2.2,
        },
        869: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
    },
});
